import React, { useEffect, useState } from "react";
import { api, formatDate } from "@/lib/api";
import { CalendarCheck, FileText, UserMinus } from "@phosphor-icons/react";
import { Loading, Empty, Panel } from "./_shared";

export default function HRDashboard({ staff }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/hr/summary/overview").then((r) => setS(r.data)); }, []);
  if (!s) return <Loading />;
  const staffName = (id) => staff.find((x) => x.id === id)?.full_name || id;
  const widgets = [
    ["Total Staff", s.totals.total_staff],
    ["Active", s.totals.active_staff],
    ["Permanent", s.totals.permanent],
    ["Project-Based", s.totals.project_based],
    ["On Probation", s.totals.on_probation],
    ["On Leave", s.totals.on_leave_count],
    ["Active Warnings", s.totals.active_warnings],
    ["Overdue Tasks", s.totals.overdue_tasks],
    ["Pending Finance Clear.", s.totals.pending_finance_clearance],
    ["Pending Admin Approval", s.totals.pending_admin_approval],
    ["Receipts Pending", s.totals.payroll_receipts_pending],
    ["Fingerprint Today", s.totals.fingerprint_attendance_today],
  ];
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 xl:grid-cols-7">
        {widgets.map(([l, v]) => (
          <div key={l} className="dc-card p-4">
            <div className="text-[10px] font-mono-alt uppercase tracking-widest text-slate-500">{l}</div>
            <div className="mt-1 text-3xl font-display font-semibold text-slate-900">{v}</div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <Panel title="Contracts Expiring (next 60 days)" icon={<FileText size={16} style={{ color: "#1E5CBA" }} />}>
          {s.contracts_expiring_60d?.length ? (
            <ul className="divide-y divide-slate-100">
              {s.contracts_expiring_60d.map((c) => (
                <li key={c.id} className="flex items-center justify-between px-5 py-3 text-sm">
                  <div><div className="font-semibold text-slate-900">{c.position}</div>
                       <div className="text-xs text-slate-500">{staffName(c.staff_id)} · {c.contract_type}</div></div>
                  <div className="font-mono-alt text-xs text-amber-600">{formatDate(c.end_date)}</div>
                </li>
              ))}
            </ul>
          ) : <Empty text="No contracts expiring in the next 60 days." />}
        </Panel>
        <Panel title="Currently on Leave" icon={<CalendarCheck size={16} style={{ color: "#059669" }} />}>
          {s.on_leave?.length ? (
            <ul className="divide-y divide-slate-100">
              {s.on_leave.map((l) => (
                <li key={l.id} className="flex items-center justify-between px-5 py-3 text-sm">
                  <div><div className="font-semibold text-slate-900">{staffName(l.staff_id)}</div>
                       <div className="text-xs text-slate-500">{l.leave_type}</div></div>
                  <div className="font-mono-alt text-xs text-slate-500">{formatDate(l.start_date)} → {formatDate(l.end_date)}</div>
                </li>
              ))}
            </ul>
          ) : <Empty text="No staff on leave today." />}
        </Panel>
      </div>
      <Panel title="Recent Separations" icon={<UserMinus size={16} style={{ color: "#dc2626" }} />}>
        {s.recent_separations?.length ? (
          <ul className="divide-y divide-slate-100">
            {s.recent_separations.map((x) => (
              <li key={x.id} className="flex items-center justify-between px-5 py-3 text-sm">
                <div><div className="font-semibold text-slate-900">{staffName(x.staff_id)}</div>
                     <div className="text-xs text-slate-500">{x.separation_type} · {x.reason?.slice(0,60)}</div></div>
                <div className="font-mono-alt text-xs text-slate-500">{formatDate(x.effective_date)}</div>
              </li>
            ))}
          </ul>
        ) : <Empty text="No recent separations." />}
      </Panel>
    </div>
  );
}
